<template>
  <v-dialog
    v-model="dialog"
    max-width="720"
    content-class="dialog-border-radius"
  >
    <areas-form-dialog-shell
      :title="isEdit ? 'Редактирование района обслуживания' : 'Новый район обслуживания'"
      :subtitle="isEdit ? '' : 'Укажите название района и назначьте мастера'"
      icon="mdi-map-marker-multiple"
      :saving="saving"
      :is-create="!isEdit"
      :save-label="isEdit ? 'Сохранить' : 'Создать район'"
      @close="close"
      @save="save"
    >
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card outlined class="areas-form-section mb-4">
          <div class="pa-4">
            <div class="areas-form-section__head">
              <div class="areas-form-section__badge">
                <v-icon>mdi-text-box-outline</v-icon>
              </div>
              <div class="areas-form-section__title-wrap">
                <h3 class="areas-form-section__title">Основные данные</h3>
                <p class="areas-form-section__desc">Название района и мастер, который его обслуживает</p>
              </div>
            </div>
            <div class="areas-form-grid">
              <v-col cols="12" class="pb-0 pt-0 areas-form-grid__full">
                <v-text-field
                  v-model="form.name"
                  label="Название района"
                  prepend-inner-icon="mdi-rename-box-outline"
                  outlined
                  dense
                  flat
                  class="areas-form-field border"
                  placeholder="Например: Северный микрорайон"
                  :rules="[v => !!v || 'Обязательное поле']"
                />
              </v-col>
              <v-col cols="12" class="pb-0 pt-0 areas-form-grid__full">
                <v-autocomplete
                  v-model="form.master_id"
                  label="Мастер"
                  :items="masters"
                  item-text="name"
                  item-value="id"
                  prepend-inner-icon="mdi-account-wrench-outline"
                  outlined
                  dense
                  flat
                  class="areas-form-field border"
                  no-data-text="Мастера не найдены"
                  :loading="mastersLoading"
                  :rules="[v => !!v || 'Обязательное поле']"
                  hint="В список попадают только пользователи с ролью «Мастер»"
                  persistent-hint
                />
              </v-col>
            </div>
          </div>
        </v-card>
      </v-form>

      <template #footer>
        <div class="areas-form-footer-info">
          <div class="areas-form-footer-info__icon-wrap">
            <v-icon class="areas-form-footer-info__icon">mdi-information-outline</v-icon>
          </div>
          <p class="areas-form-footer-info__text mb-0">
            Район обслуживания объединяет участки МТО. Мастер назначается на район
            и автоматически относится ко всем входящим в него участкам.
          </p>
        </div>
      </template>
    </areas-form-dialog-shell>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import UserService from '@/services/api/user';
import AreasFormDialogShell from '@/components/areas/AreasFormDialogShell';

export default {
  name: 'ServiceAreaFormDialog',
  components: { AreasFormDialogShell },
  props: {
    value: Boolean,
    item: {
      type: Object,
      default: null,
    },
  },
  data () {
    return {
      valid: false,
      saving: false,
      mastersLoading: false,
      masters: [],
      form: {
        name: '',
        master_id: null,
      },
    };
  },
  computed: {
    dialog: {
      get () { return this.value; },
      set (val) { this.$emit('input', val); },
    },
    isEdit () {
      return !!(this.item && this.item.id);
    },
  },
  watch: {
    value (open) {
      if (open) {
        this.resetForm();
        this.loadMasters();
      }
    },
  },
  methods: {
    ...mapActions({
      createServiceArea: 'ServiceArea/createServiceArea',
      updateServiceArea: 'ServiceArea/updateServiceArea',
    }),
    async loadMasters () {
      this.mastersLoading = true;
      try {
        const { data } = await UserService.getUsers({
          filters: { 'role.name': 'master' },
        });
        this.masters = data.users || [];
      } catch (e) {
        this.masters = [];
      } finally {
        this.mastersLoading = false;
      }
    },
    resetForm () {
      if (this.isEdit) {
        this.form = {
          name: this.item.name,
          master_id: this.item.master_id || this.item.master?.id || null,
        };
      } else {
        this.form = { name: '', master_id: null };
      }
      this.$nextTick(() => {
        if (this.$refs.form) this.$refs.form.resetValidation();
      });
    },
    close () {
      this.dialog = false;
    },
    save () {
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      const payload = {
        name: this.form.name,
        master_id: this.form.master_id,
      };
      const action = this.isEdit
        ? this.updateServiceArea({ id: this.item.id, data: payload })
        : this.createServiceArea(payload);

      action
        .then(() => {
          this.$flash_success('Сохранено');
          this.$emit('saved');
          this.close();
        })
        .catch((err) => {
          this.handleError(err);
        })
        .finally(() => {
          this.saving = false;
        });
    },
    handleError (err) {
      if (err.response && err.response.status === 422) {
        const response = err.response.data;
        for (const input in response) {
          if (Array.isArray(response[input])) {
            response[input].forEach(error => this.$flash_warning(`${input}: ${error}`));
          }
        }
      } else {
        this.$flash_warning('Ошибка при сохранении');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './areasFormDialog.scss';
</style>
